import { useState, useEffect } from 'react';

const useWidgetLayout = () => {
  let widgetLayout;
  const [widgetWidth, setWidgetWidth] = useState();
  const handleResize = () =>
    setWidgetWidth(document.querySelector('form').parentElement.clientWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  switch (true) {
    // Small content column
    case widgetWidth >= 560 && widgetWidth < 750:
      widgetLayout = 'verticalsmall';
      break;
    // Main content column
    case widgetWidth >= 750 && widgetWidth < 1020:
      widgetLayout = 'vertical';
      break;
    // Full width column (with hero skin)
    case widgetWidth >= 1020 && widgetWidth < 1150:
      widgetLayout = 'horizontalsmall';
      break;
    // Full width column
    case widgetWidth >= 1150:
      widgetLayout = 'horizontal';
      break;
  }

  return widgetLayout;
};

export default useWidgetLayout;
